import axios from "axios";
import * as baseURL from "./baseurl";

const instance = axios.create({
  baseURL: baseURL.BASEURL + "/Users/",
  withCredentials: true,
});

export default instance;
